<template>
    <div class="f-13 f-semi f-c-white">
        <p style="text-align: left">
            {{ keterangan }}
        </p>
        <ul class="m-d-0" style="text-align: left; margin-left: -16px">
            <li>Misal, tagihan awal transaksi: {{ defaultCost | currency }}</li>
            <li>
                Dengan biaya
                <span class="f-c-green"> &nbsp;{{ percent }}% </span>
                , maka:
                <span class="f-c-green"> &nbsp;+{{ getContohCost | currency }} </span>
            </li>
            <li>
                Total yg harus dibayar menjadi:&nbsp;
                {{ getAllCost | currency }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "Tooltips",
    data() {
        return {
            defaultCost: 20000,
        };
    },
    props: {
        keterangan: {
            type: String,
            required: true,
        },
        percent: {
            type: Number,
            required: true,
        },
    },
    computed: {
        getContohCost() {
            return (this.defaultCost * this.percent) / 100;
        },
        getAllCost() {
            return this.defaultCost + this.getContohCost;
        },
    },
};
</script>
